import axios from "axios";
import authHeader from "@/services/auth-header";
import {WALLETS_ENDPOINT} from "@/constants/endpoints";
import QueryUtils from "@/utils/QueryUtils";
import Page from "@/dto/taxation/Page";
import {
    DepositPayload,
    ReversePayload,
    TransferPayload,
    WalletTransactionView,
    WalletView,
    WithdrawPayload,
} from "@/dto/wallet/WalletDTOs";

export const WALLET_TRANSACTION_PAGE_SIZE = 40;

class WalletService {

    getWallet(companyId: number) {
        return axios.get<WalletView>(`${WALLETS_ENDPOINT}/company/${companyId}`, {headers: authHeader()});
    }

    getTransactions(companyId: number, pageNumber = 1, pageSize = WALLET_TRANSACTION_PAGE_SIZE) {
        const queryString = QueryUtils.buildQueryString(
            ["pageNumber", pageNumber],
            ["pageSize", pageSize],
        );
        return axios.get<Page<WalletTransactionView>>(
            `${WALLETS_ENDPOINT}/company/${companyId}/transactions${queryString}`,
            {headers: authHeader()},
        );
    }

    getTransaction(companyId: number, id: number) {
        return axios.get<WalletTransactionView>(
            `${WALLETS_ENDPOINT}/company/${companyId}/transactions/${id}`,
            {headers: authHeader()},
        );
    }

    deposit(companyId: number, payload: DepositPayload) {
        return axios.post<WalletTransactionView>(
            `${WALLETS_ENDPOINT}/company/${companyId}/deposits`,
            payload,
            {headers: authHeader()},
        );
    }

    withdraw(companyId: number, payload: WithdrawPayload) {
        return axios.post<WalletTransactionView>(
            `${WALLETS_ENDPOINT}/company/${companyId}/withdrawals`,
            payload,
            {headers: authHeader()},
        );
    }

    transfer(companyId: number, payload: TransferPayload) {
        return axios.post<Array<WalletTransactionView>>(
            `${WALLETS_ENDPOINT}/company/${companyId}/transfers`,
            payload,
            {headers: authHeader()},
        );
    }

    reverse(transactionId: number, payload: ReversePayload | null = null) {
        return axios.post<Array<WalletTransactionView>>(
            `${WALLETS_ENDPOINT}/transactions/${transactionId}/reversal`,
            payload || {},
            {headers: authHeader()},
        );
    }
}

export default new WalletService();
